function initSubscriptionWidget() {
    // Event delegation for radio button changes
    document.body.addEventListener('change', function(event) {
        if (event.target.matches('input[name="nw-plan-picker"]')) {
            const selectedValue = event.target.value;
            
            if (selectedValue === 'subscription') {
                //console.log('Subscription selected');
                // Add your custom code for subscription selection here
                
                // Example: Show/hide price elements
                document.querySelectorAll('[data-subscription-element]').forEach(el => {
                    el.classList.remove('hidden');
                });
                document.querySelectorAll('[data-onetime-element]').forEach(el => {
                    el.classList.add('hidden');
                });
            } else if (selectedValue === 'one-time') {
                //console.log('One-time purchase selected');
                // Add your custom code for one-time purchase selection here
                
                // Example: Show/hide price elements
                document.querySelectorAll('[data-subscription-element]').forEach(el => {
                    el.classList.add('hidden');
                });
                document.querySelectorAll('[data-onetime-element]').forEach(el => {
                    el.classList.remove('hidden');
                });
            }
        }
    });
}

function getBundleDiscountCode(contextNode) {
    const rootNode = contextNode instanceof Element ? contextNode.closest('#nw-subscription-widget') : document.querySelector('#nw-subscription-widget');
    const discountCode = rootNode?.dataset.bundleDiscount?.trim();
    return discountCode || null;
}

async function applyDiscountToCart(discountCode) {
    if (!discountCode) {
        return;
    }

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                discount: discountCode
            })
        });

        if (!response.ok) {
            const errorPayload = await response.json().catch(() => ({}));
            const errorMessage = errorPayload?.description || 'Failed to apply discount';
            throw new Error(errorMessage);
        }
    } catch (error) {
        console.warn(`Failed to apply discount code "${discountCode}"`, error);
    }
}

// Function to get additional products selections (size, color, etc.)
function getAdditionalProductsProperties() {
    const properties = {};
    const additionalProductItems = document.querySelectorAll('.additional-product-item');
    
    additionalProductItems.forEach((item, index) => {
        const productHandle = item.getAttribute('data-additional-product-item');
        
        // Get selections from dropdowns
        const variantSelects = item.querySelectorAll('.additional-product-variant-select');
        variantSelects.forEach(select => {
            const optionLabel = select.closest('.variant-option-group')?.querySelector('.variant-option-label span')?.textContent || 'Option';
            const optionValue = select.value;
            if (optionValue) {
                properties[optionLabel] = optionValue;
            }
        });
        
        // Get selections from color swatches
        const activeColorSwatch = item.querySelector('.additional-product-color-swatch.active');
        if (activeColorSwatch) {
            const colorValue = activeColorSwatch.getAttribute('data-option-value-raw');
            if (colorValue) {
                properties['Color'] = colorValue.toLowerCase();
            }
        }
        
        // Get selections from size buttons
        const activeSizeButton = item.querySelector('.additional-product-size-button.active');
        if (activeSizeButton) {
            const sizeValue = activeSizeButton.getAttribute('data-option-value-raw');
            if (sizeValue) {
                properties['Size'] = sizeValue;
            }
        }
    });
    
    return properties;
}

// Add to cart function
async function handleAddToCart(button) {
    // Add loading state
    button.classList.add('loading');
    
    try {
        const discountCode = getBundleDiscountCode(button);

        // Get the selected variant ID
        const variantId = document.querySelector('variant-selects[data-selected-id]')?.getAttribute('data-selected-id');
        if (!variantId) {
            throw new Error('No variant selected');
        }

        // Get the selected purchase type (subscription or one-time)
        const selectedPurchaseType = document.querySelector('input[name="nw-plan-picker"]:checked')?.value;
        
        // Get additional products properties (size, color, etc.)
        const additionalProductsProperties = getAdditionalProductsProperties();
        
        // Check for additional products first to collect their IDs
        const additionalProductInputs = document.querySelectorAll('[data-additional-item]');
        const additionalVariantIds = [];
        
        if (additionalProductInputs.length > 0) {
            additionalProductInputs.forEach(input => {
                const additionalVariantId = input.value;
                if (additionalVariantId) {
                    additionalVariantIds.push(additionalVariantId);
                }
            });
        }

        // Prepare cart data - start with main product
        const cartData = {
            items: [{
                id: variantId,
                quantity: 1
            }]
        };
        
        // Initialize properties object
        const mainProductProperties = {};
        
        // Add additional product selections properties if available
        if (Object.keys(additionalProductsProperties).length > 0) {
            Object.assign(mainProductProperties, additionalProductsProperties);
        }
        
        // Add _additional_item property if additional items are available (underscore prefix hides it from checkout)
        if (additionalVariantIds.length > 0) {
            // Join multiple IDs with comma if there are multiple, otherwise use single ID
            mainProductProperties._additional_item = additionalVariantIds.join(',');
        }
        
        // Add properties to main product if we have any
        if (Object.keys(mainProductProperties).length > 0) {
            cartData.items[0].properties = mainProductProperties;
        }

        // If subscription is selected, add selling plan
        if (selectedPurchaseType === 'subscription') {
            const sellingPlanSelect = document.querySelector('select[name="selling_plan"]');
            if (sellingPlanSelect) {
                const sellingPlanId = sellingPlanSelect.value;
                cartData.items[0].selling_plan = sellingPlanId;
            }
        }

        // Add additional products to cart items
        if (additionalVariantIds.length > 0) {
            additionalVariantIds.forEach(additionalVariantId => {
                cartData.items.push({
                    id: additionalVariantId,
                    quantity: 1,
                    parent_id: variantId
                });
            });
        }

        // Add to cart API call
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartData)
        });

        if (!response.ok) {
            throw new Error('Failed to add to cart');
        }

        const result = await response.json();
        //console.log('Added to cart:', result);

        if (discountCode) {
            await applyDiscountToCart(discountCode);
        }

        // Refresh cart and open drawer
        fetch('/cart?view=ajax')
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                var parser = new DOMParser();
                var cartHTML = parser.parseFromString(html, 'text/html');
                var cart_ajax = document.querySelector('#cart-main-ajax');
                cart_ajax.innerHTML = cartHTML.querySelector('body').innerHTML;
                
                // Run any additional cart functions if they exist
                if (typeof bindQuantityFields === 'function') {
                    bindQuantityFields();
                }
                if (typeof reloadShoppingGivesWidget === 'function') {
                    setTimeout(reloadShoppingGivesWidget, 100);
                }
                if (typeof clearCartAttributesIfEmpty === 'function') {
                    clearCartAttributesIfEmpty();
                }
            })
            .catch(error => console.warn('Something went wrong refreshing cart.', error))
            .finally(() => {
                if (typeof toggleCartLoader === 'function') {
                    toggleCartLoader(false);
                }
            });

        // Open cart drawer
        const ajaxCart = document.querySelector('.ajax-cart');
        if (ajaxCart && !ajaxCart.classList.contains('open')) {
            ajaxCart.classList.add('open');
        }

    } catch (error) {
        console.error('Error adding to cart:', error);
        // Optional: Show error message to user
    } finally {
        // Remove loading state
        button.classList.remove('loading');
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initSubscriptionWidget);

// Watch for dynamic content changes
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
            // Check if our widget is added
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && (
                    node.matches('#nw-subscription-widget') || 
                    node.querySelector('#nw-subscription-widget')
                )) {
                    initSubscriptionWidget();
                }
            });
        }
    });
});

// Start observing the body for dynamic changes
observer.observe(document.body, {
    childList: true,
    subtree: true
});
